import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { combineReducers } from 'redux'
import { authReducer } from './reducers/auth'
import { planReducer } from './reducers/plans'
import { settingsReducer } from './reducers/settings'
import { profileReducer } from './reducers/profileReducer'
import { bankReducer } from './reducers/bankReducer'
import { faqReducer } from './reducers/faqReducer'
import { getReferralDetailsReducer } from './reducers/referralReducer'
import { portfolioReducer } from './reducers/portfolioReducer'
import { transactionReducer } from './reducers/transaction'
import { CardReducer } from './reducers/cards'
import { userPlanReducer } from './reducers/userPlanReducer'
import { CollaboReducer } from './reducers/collaboReducer'
import { investReducer } from './reducers/invest'
import { xContestReducer } from './reducers/xcontest'

const rootReducer = combineReducers({
  auth: authReducer,
  plan: planReducer,
  setting: settingsReducer,
  banksResult: bankReducer,
  profile: profileReducer,
  referrals: getReferralDetailsReducer,
  faqs: faqReducer,
  portfolios: portfolioReducer,
  transactionsReducer: transactionReducer,
  cards: CardReducer,
  userPlanReducer: userPlanReducer,
  collabo: CollaboReducer,
  invest: investReducer,
  xcontest: xContestReducer,
})

// export default appReducer;

// const rootReducer = (state: any, action: any) => {
//   if (action.type === "CLEAR_ALL_STATE") {
//     state = undefined;
//   }

//   return appReducer(state, action);
// };

export type RootState = ReturnType<typeof rootReducer>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export default rootReducer
